
import axios from "./index";

//fetch all notifications
export async function fetchNotification(pageNumber) {
    return axios.post(`/notification/fetch`, {pageNumber})
      .then((res) => res.data);
  }